// Skeleton Component
interface ButtonGroupSkeletonProps {
    length: number
    className?: string
}

export const ButtonGroupSkeleton = ({
    length,
    className = '',
}: ButtonGroupSkeletonProps) => {
    return (
        <div className={`flex items-center ${className} w-full gap-2`}>
            {Array.from({ length }).map((_, index) => (
                <div
                    key={index}
                    className="rounded-md p-3 w-full bg-gray-100 animate-pulse"
                >
                    <div className="flex items-center justify-center gap-2">
                        {/* Icon skeleton */}
                        <div className="w-4 h-4 bg-gray-200 rounded animate-pulse" />

                        {/* Text skeleton */}
                        <div className="w-16 h-4 bg-gray-200 rounded animate-pulse" />

                        {/* Count skeleton (random appearance) */}
                        {Math.random() > 0.5 && (
                            <div className="w-5 h-5 bg-gray-200 rounded animate-pulse" />
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}
export default ButtonGroupSkeleton
